<template>
    <div class="shipping-info">
        <i class="ico ico-shadow-truck">
            <i class="path1"></i>
            <i class="path2"></i>
        </i>

        <span>
            {{ shippingText }}
        </span>
    </div>
</template>

<script>
import { formatPrice } from "./../../../../vendor/rshop/frontend/assets/js/common/format";

export default {
    props: {
        initialData: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        freeLimit: null,
        freeAmount: null,
        productPrice: null,
        hasProductFreeShipping: null,
        isEmptyCart: false,
        texts: [],
    }),
    computed: {
        hasFreeShipping() {
            return this.hasProductFreeShipping || this.productPrice >= this.freeLimit;
        },
        shippingText() {
            let textKey = "";

            if (this.hasFreeShipping) {
                textKey = this.freeAmount > 0 ? "textProductFree" : "textFree";
            } else if (this.isEmptyCart) {
                textKey = this.hasFreeShipping ? "textProductFree" : "textEmpty";
            } else {
                textKey = this.freeAmount > 0 ? "text" : "textFree";
            }

            return this.texts[textKey]
                .replace(":freeAmount", formatPrice(this.freeAmount))
                .replace(":freeLimit", formatPrice(this.freeLimit));
        },
    },
    created() {
        this.freeLimit = this.initialData.freeLimit;
        this.freeAmount = this.initialData.freeAmount;
        this.productPrice = this.initialData.productPrice;
        this.hasProductFreeShipping = this.initialData.hasProductFreeShipping;
        this.isEmptyCart = this.initialData.isEmptyCart;
        this.texts = this.initialData.texts;

        window.Event.on("Custom.Cart.addedItem", (data) => {
            this.updateData(data.response);
        });
        window.Event.on("Custom.Cart.updatedItem", (data) => {
            this.updateData(data.response);
        });
        window.Event.on("Custom.Cart.removedItem", (data) => {
            this.updateData(data.response);
        });
    },
    methods: {
        updateData(response) {
            if (!response.free_shipping) {
                return;
            }

            this.freeAmount = response.free_shipping.price;
            this.isEmptyCart = response.totals.quantity <= 0;
        },
    },
};
</script>
